import { lazy } from "react";
import { Route } from "react-router-dom";

import DesktopUserLayout from "@/layouts/desktop/desktop-user-layout";
import DashboardPage from "@/pages/desktop/dashboard-page";
import DesktopActiveMeetingsPage from "@/pages/desktop/desktop-active-meets-page";

const LooppsPage = lazy(() => import("@/pages/desktop/loops-page"));
const NetworkPage = lazy(() => import("@/pages/desktop/network-page"));
const RecordingsPage = lazy(() => import("@/pages/desktop/recordings-page"));
const CalendarPage = lazy(() => import("@/pages/desktop/calendar-page"));
const SettingsPage = lazy(() => import("@/pages/desktop/settings/settings-page"));

const AdminDashboardPage = lazy(() => import("@/pages/desktop/admin/admin-dashboard-page"));
const AdminUsagePage = lazy(() => import("@/pages/desktop/admin/admin-usage-page"));
const MeetingLinkPage = lazy(() => import("@/pages/desktop/meeting-link-page"));
const AdminUsersPage = lazy(() => import("@/pages/desktop/admin/admin-users-page"));

export function DesktopRoutes({ isAdmin = false } = {}) {
  return (
    <Route path="/" element={<DesktopUserLayout />}>
      <Route index element={<DashboardPage />} />
      <Route path="loops" element={<LooppsPage />} />
      <Route path="network" element={<NetworkPage />} />
      <Route path="recordings" element={<RecordingsPage />} />
      <Route path="calendar" element={<CalendarPage />} />
      <Route path="settings" element={<SettingsPage />} />

      <Route path="/meetings/join/:short_code" element={<DesktopActiveMeetingsPage />} />

      <Route path="/meetings/view/:short_code" element={<MeetingLinkPage />} />
      {isAdmin && <Route path="/admin/overview" element={<AdminDashboardPage />} />}
      {isAdmin && <Route path="/admin/users" element={<AdminUsersPage />} />}
      {isAdmin && <Route path="/admin/usage" element={<AdminUsagePage />} />}
    </Route>
  );
}
